// config.js
const config = {
  BASE_URL: "https://emmppe.raisondigital.com",
};

export default config;
 